import * as React from 'react';

export const SortAscIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      d="M 9.24 13.886 C 9.177 13.823 9.141 13.738 9.141 13.649 C 9.141 13.56 9.177 13.475 9.24 13.412 L 9.373 13.279 C 9.436 13.214 9.523 13.178 9.613 13.179 L 14.387 13.179 C 14.477 13.178 14.564 13.214 14.627 13.279 L 14.76 13.412 C 14.823 13.475 14.859 13.56 14.859 13.649 C 14.859 13.738 14.823 13.823 14.76 13.886 L 12.233 16.412 C 12.173 16.477 12.088 16.513 12 16.513 C 11.912 16.513 11.827 16.477 11.767 16.412 L 9.24 13.886 Z"
      fill="#bdbfc7"
    ></path>
    <path
      d="M 14.76 10.115 C 14.823 10.178 14.859 10.263 14.859 10.352 C 14.859 10.44 14.823 10.526 14.76 10.588 L 14.627 10.722 C 14.564 10.787 14.477 10.823 14.387 10.822 L 9.614 10.822 C 9.523 10.823 9.436 10.787 9.374 10.722 L 9.24 10.588 C 9.177 10.526 9.142 10.44 9.142 10.352 C 9.142 10.263 9.177 10.178 9.24 10.115 L 11.767 7.588 C 11.828 7.524 11.912 7.487 12 7.487 C 12.089 7.487 12.173 7.524 12.234 7.588 L 14.76 10.115 Z"
      fill="#175fff"
    ></path>
  </svg>
);
